import React, { Component } from "react";
import { Grid, Button, GridColumn, Icon } from "semantic-ui-react";
import EventsBackgroundColor from "./../Shared/EventsBackgroundColor";
import { BrowserView, MobileView, isBrowser, isMobile, withOrientationChange } from "react-device-detect";
import axios from "axios";
import { Route, IndexRoute } from "react-router";
import { Link } from "react-router-dom";
const eventCat = require("./data/eventCategory.json");
const periodCat = require("./data/periodCategory2.json");
const { apiUrl } = require('./config')

const { categObj } = require("./categ");
const { 
  getCategory
} = require("../Shared/utils");


function isEmpty(obj) {
  for (var key in obj) {
    if (obj.hasOwnProperty(key)) return false;
  }
  return true;
}

class EventSliderIndex extends Component {
  state = {
    eventItem: {},
    eventId: ''
  }

  componentDidUpdate = (props) => {
    console.log("componentDidUpdatecomponentDidUpdate", props);


  }

  componentWillMount = () =>{
    console.log("propsPeriodEventMountPeriod", this.props);
    var id = window.location.pathname.split('/')
    var eventId = id[3]
    var eventFilter =  this.props.location.state.items.list.filter((item)=>{
      return item.id == eventId
    })

    console.log('eventFilter',eventFilter)
    this.setState({
      eventId: eventId,
      eventItem: eventFilter[0],
      period: this.props.location.state.items
    })
  }

  handleClicks = (periodId, categoryId, eventId) => {
    // window.location.replace(`/timeline/#${periodId}/?periodId=${periodId}&categoryId=${categoryId}&eventId=${eventId}`);
    window.location.replace(`/epa_timeline/#id${eventId}`);
  }

  render() {
    console.log("eventslider/STate", this.state);
    var { eventItem, period } = this.state;
    var regex = /(<([^>]+)>)/gi;
    return (
      <div
          className={`container-period col-xl-12 period-container bg-img p-0`}
          style={{
            backgroundImage: `url('${period.background_image == null ? '': period.background_image.meta.download_url}')`,
            // backgroundColor: `${period.period_color}`,
            // backgroundBlendMode: "soft-light",
            width: '100vw'
          }}
        >
        <div class="inner">
          <div className={`${eventItem.photo == null ? 'center-div' : ''}`}>
          {eventItem.photo == null ? '' : 
                  (
                <div className={`${eventItem.photo.width > eventItem.photo.height && eventItem.photo.height < 450? 'col-8 col-lg-8 col-xl-8 m-auto p-0 landscape' : eventItem.photo.width < eventItem.photo.height && eventItem.photo.height >= 450 ? 'col-8 col-lg-3 col-xl-3 m-auto p-0 portrait' : 'col-8 col-lg-3 col-xl-3 m-auto p-0 even'}`}>
                    <div class="pt-1">
                      <div>
                        {/* <a href={item.photo.url} data-lightbox={item.id} data-title={item.caption}> */}
                          <img className="w-100 img-sample" src={eventItem.photo.url} />
                        {/* </a> */}
                      </div>
                    </div>
                </div>
              )
            }
            <Grid className="m-0 pb-5">
              <Grid.Column width={2}></Grid.Column>
              <Grid.Column width={11} className="mt-0 ml-3 px-0 pb-0 pt-2 m-auto">
                <div className="mt-4">
        
                  <p className="event-title-historical text-white mt-3">
                    {eventItem.display_name == "" || eventItem.display_name == null
                                      ? eventItem.complete_start_date
                                      : eventItem.display_name}
                    <span className={`event-category text-white  ${eventItem.category == '' || eventItem.display_name == '' || eventItem.complete_start_date == '' ? "d-none" : ""}`}>| {eventItem.category}</span>
                  </p>
                </div>
                <div className="col-md-6 mt-2 p-0">
                  <hr className="hr-gold mb-2 mt-2" />
                </div>
    
                <p className="event-description-historical text-white font-style-3">
                  {/* {eventItem.description.replace(regex, "")} */}
                  <div dangerouslySetInnerHTML={{ __html: `${eventItem.description}` }} />
                </p>
              </Grid.Column> 
              <Grid.Column width={2}></Grid.Column>
            </Grid>
          </div>
        </div>
        <div class="zIndex-999">
            <div class="">
            <Link className="link-event" to={{
                  pathname: `/epa_timeline/#id${eventItem.id}`,
                  state: {
                    periodId:  period.id, 
                    categoryId:  eventItem.categories[0].pk, 
                    categoryName:  getCategory(eventItem.categories[0].pk), 
                    eventId: eventItem.id
                  }
                }}>
              <Button className="top-left-corner rounded-0 btn-event-back mr-3 p-0 font-weight-bold" content="Scroll Down" onClick={this.handleClicks.bind(this, period.id, eventItem.categories[0].pk, eventItem.id)}>
              {/* <Button className="rounded-0 btn-event-back mr-3 p-0 font-weight-bold" content="Scroll Down"> */}
                <Icon name="long arrow alternate left" />
                Back
              </Button>
              </Link>
            </div>
          </div> 
          <div class="">
            <div class="">
            <p className="top-right-corner event-slider-period-category text-white text-uppercase text-right ">
                  {period.period_slider_display_name}
            </p>
            </div>
          </div> 
      </div>
    );
  }
}

export default EventSliderIndex;